
<!--
 * @Author: zhao.yang
 * @Description: 暂无
 -->

<template>
  <div @click="handleSellect" class="skill-item">
    <img
      :src="skillImgUrl.url"
      alt=""
    />
    <p>{{skillImgUrl.label}}</p>
    <div class="skill-shadow" :class="selected && 'hover'"></div>
  </div>
</template>

<script>

export default {
  data() {
    return {
    }
  },
  props: {
    skillImgUrl: {
      type: Object,
      default: () => {
        return {}
      }
    },
    selected:{
      type: Boolean,
      default:()=>{
        return false;
      }
    }
  },
  created() {
    const src = this.skillImgUrl.url
    if (/\?d=/.test(src)) {
      this.coverSrc = src
    }
  },
  methods: {
    handleSellect() {
      this.$emit('handleSellect', this.skillImgUrl.id)
    }
  },
}
</script>

<style lang="scss" scoped>
  .skill-shadow{
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100px;
    left: 0;
    top: 0;
    &:hover,&.hover{
      background: url('./images/Union.png') no-repeat center center,linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6));
      background-size: 13.5px;
    }
  }
  .skill-item{
    cursor: pointer;
    position: relative;
    width: 100px;
    height: 126px;
    border-radius: 6px;
    overflow: hidden;
    text-align: center;
    margin-bottom: 24px;
    img{
      width: 100px;
      height: 100px;
      border-radius: 6px;
    }
    p{
      font-size: 13px;
      line-height: 18px;
      letter-spacing: -0.3px;
      color: #222C43;
    }
  }
</style>
